import styled from 'styled-components';
import { MOBILE, EXTRA_LARGE, TABLET } from '@minerva-analytics/pantheon';

const HeroContainer = styled.div`
  width: 90%;
  text-align: left;
  padding-top: 0;
  padding-left: 2rem;
  padding-right: 2rem;
  @media (max-width: ${TABLET}) {
    margin: 0 auto;
    padding: 0;
  }
  @media (min-width: ${EXTRA_LARGE}) {
    max-width: 550px;
  }
`;


const HomeContainer = styled.div`
  display: flex;
  @media (min-width: ${EXTRA_LARGE}) {
    flex-direction: row;
    width: 90%;
  }
  align-items: left;
  margin: auto;

  flex-direction: column;
  padding-bottom: 1rem;
  width: 100%;

`;

const ImageContainer = styled.div`
  @media (min-width: ${EXTRA_LARGE}) {
    position: absolute;
    top: 9px;
    right: 0;
  }
  z-index: -1;
`;

const Image = styled.img`
  max-width: 100%;
  content: url("https://storage.googleapis.com/cookingandcocktails-assets/BG-img-CC_tablet.png");
  @media (min-width: ${EXTRA_LARGE}) {
    width: auto;
    height: auto;
    max-width: 1440px;
    max-height: 720px;
    display: block;
    content: url("https://storage.googleapis.com/cookingandcocktails-assets/BG-img-CC.png");
  }

`;

const LinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 300px;
  margin: 0 auto;
`;

const SocialButtonContainer = styled.div`
  display: inline-flex;
  justify-content: space-between;
  padding-left: 20px;
  text-align: center;
  width: 150px;
  @media (max-width: ${MOBILE}) {
    padding-left: 0;
  }
`;

export {
  HeroContainer,
  HomeContainer,
  ImageContainer,
  LinkContainer,
  SocialButtonContainer,
  Image
};
